var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoSearchResultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graphic-2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    transform: "translate(0.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.9664 16.1333C22.6331 19.9333 19.9664 23.3333 19.9664 23.3333C19.9664 23.3333 18.1664 21.1333 16.2997 18.2667C14.0331 14.8667 11.5664 10.6 11.5664 8.13333C11.5664 4.2 15.2997 0 19.9664 0C24.6331 0 28.2997 4.2 28.3664 8.13333C28.2997 10.0667 26.7664 13.2 24.9664 16.1333Z",
    fill: "url(#paint0_linear_8039_50672)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.3005 18.1995C18.2339 21.0662 19.9672 23.2662 19.9672 23.2662C19.9672 23.2662 22.6339 19.8662 24.9672 16.0662L26.1672 15.7995V35.6662L15.3672 38.3328V18.4662L16.3005 18.1995Z",
    fill: "url(#paint1_linear_8039_50672)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M37.0333 18.4662V38.3328L26.1666 35.6662H26.2333V15.7995L37.0333 18.4662Z",
    fill: "url(#paint2_linear_8039_50672)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.3667 18.4662V38.3328L4.5 35.6662V15.7995L15.3667 18.4662Z",
    fill: "url(#paint3_linear_8039_50672)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M19.9661 12.1328C22.3594 12.1328 24.2995 10.1927 24.2995 7.79946C24.2995 5.40622 22.3594 3.46613 19.9661 3.46613C17.5729 3.46613 15.6328 5.40622 15.6328 7.79946C15.6328 10.1927 17.5729 12.1328 19.9661 12.1328Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8039_50672",
    x1: 19.9664,
    y1: 0,
    x2: 19.9664,
    y2: 23.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8039_50672",
    x1: 20.7672,
    y1: 15.7995,
    x2: 20.7672,
    y2: 38.3328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8039_50672",
    x1: 31.6,
    y1: 15.7995,
    x2: 31.6,
    y2: 38.3328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8039_50672",
    x1: 9.93333,
    y1: 15.7995,
    x2: 9.93333,
    y2: 38.3328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E5E5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSearchResultIcon);
export default __webpack_public_path__ + "static/media/no-search-result-icon.3ece8e13b77dbdd44a97da4600d781e8.svg";
export { ForwardRef as ReactComponent };